module.exports = __webpack_public_path__ + "img/profile-circle-linear-40x40.c0281657.svg";